/**
 * @file PublicProfile.jsx — /c/:slug
 *
 * Old Vite version. The public profile is now served by the Next.js
 * project at consultto.mx/c/:slug via Vercel rewrites. In production,
 * this route is unreachable. In local dev, redirect to VITE_PUBLIC_SITE_URL
 * (set this to your local Next.js dev URL, e.g. http://localhost:3001,
 * in .env.development.local). Falls back to consultto.mx if unset.
 */
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Spinner } from "../ui";

const PROFILE_BASE_URL = import.meta.env.VITE_PUBLIC_SITE_URL || "https://consultto.mx";

export default function PublicProfile() {
  const { slug } = useParams();
  useEffect(() => {
    if (slug) {
      window.location.replace(`${PROFILE_BASE_URL}/c/${slug}`);
    }
  }, [slug]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60dvh",
        gap: 12,
      }}
    >
      <Spinner size={32} />
      <p style={{ color: "var(--ink-3)", margin: 0 }}>Redirigiendo al perfil...</p>
    </div>
  );
}
